<template>
  <div class="dashboard">
    <header-navigation />
    <div class="container">
      <oops ref="hOops" />
      <error ref="hError" />
      <div class="searchBar">
        <input
          @keyup.enter="search()"
          v-model="searchQuery"
          placeholder="Search by Vessel Name or MMSI"
        />
      </div>
      <div class="searchContent" :key="searchShips">
        <table class="staticTable">
          <thead>
            <tr>
              <th scope="col">Country</th>
              <th scope="col">Shipname</th>
              <th scope="col">Owner</th>
              <th scope="col">Type</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(obj, index) in searchShips" :key="index">
              <td data-label="Country">
                <img :src="flagImg(obj.flag)" class="dashFlag" />
              </td>
              <td data-label="Shipname">
                <router-link
                  :to="{ name: 'Vessels', params: { mmsi: obj.mmsi } }"
                  class="link"
                  >{{ obj.name }}</router-link
                >
              </td>
              <td data-label="Owner">{{ obj.owner }}</td>
              <td data-label="Type">{{ obj.type }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <bottom-credits />
  </div>
</template>

<script>
import axios from "axios";
import Oops from "../components/Oops.vue";
import Error from "../components/Error.vue";
import BottomCredits from "../components/BottomCredits.vue";
import HeaderNavigation from "../components/HeaderNavigation.vue";
import { matchFlag } from "../helpers/FillFlag.js";
import { loadModules } from "esri-loader";

export default {
  name: "Home",
  components: {
    HeaderNavigation,
    BottomCredits,
    Oops,
    Error,
  },
  data: () => ({
    searchShips: [],
    searchQuery: "",
  }),
  methods: {
    search: function () {
      var globv = this;
      globv.$refs.hError.reset();
      globv.$refs.hOops.reset();

      if (globv.searchQuery.length == 9 && !isNaN(parseFloat(globv.searchQuery)) && isFinite(globv.searchQuery)) {
        this.$router.push({
          path: `/vessels/${globv.searchQuery}`
        });
      }

      axios
        .get("/api/search/" + globv.searchQuery)
        .then((response) => {
          for (let vessel of response["data"]) {
            if (vessel["flag"]) {
              let flag = vessel["flag"];

              if (flag) {
                let [tempFlag, formatFlag] = matchFlag(flag);

                if (formatFlag) {
                  vessel["flag"] = tempFlag;
                } else {
                  console.log("Didn't find flag match:", flag);
                  flag = null;
                }
              }
            }
          }

          globv.searchShips = response["data"];
        })
        .catch((error) => {
          globv.handleError(error);
        });
    },
    flagImg: function (flag) {
      return flag ? require("../assets/flags/svg/" + flag + ".svg") : "";
    },
    handleError: function (error) {
      var globv = this;
      error = error.response.data;
      if (error["error"] && error["error"]["status"] < 500) {
        if (error["error"]["status"] == 404)
          globv.$refs.hError.showError({
            status: 404,
            title: "Not Found",
            message: error["error"]["message"],
          });
        else
          globv.$refs.hError.showError({
            status: error["error"]["status"],
            message: error["error"]["message"],
          });
      } else globv.$refs.hOops.showOops();
    }
  },
};
</script>

<style lang="scss">
.searchBar {
  height: 85px;
  position: relative;
  background: #0057e7;

  input {
    width: 60%;
    height: 45px;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    padding: 15px;
    margin: 0 0 10px 0;
  }
}

.searchContent {
  width: 90vw;
  min-width: 360px;
  max-width: 1100px;
  align-self: center;
}

.dashFlag {
  height: 2rem;
}
</style>